<ng-container *ngIf="errorData">
  <mat-card class="card b-error">
    <mat-card-header>
      <mat-card-title class="c-error">{{
        errorData.statusText
      }}</mat-card-title>
      <mat-card-subtitle class="c-error">{{
        errorData.error.message
      }}</mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
      <div class="justify-between">
        <small class="card-comment c-error">{{ errorData.name }}</small>
        <small class="card-comment c-error"
          >status: {{ errorData.status }}</small
        >
      </div>
    </mat-card-content>
  </mat-card>
</ng-container>
